// extracted by mini-css-extract-plugin
export default {"Nabery":"Nabery_Nabery__Z4yd2"};